
import React from 'react';
import { useDispatch} from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import useAuthNeedActivation from '../../common/client/hooks/mysliveckyportal/useAuthNeedActivation';
import useAuthToken from '../../common/client/hooks/mysliveckyportal/useAuthToken';
import { getActions as authGetActions } from '../../common/client/sagas/auth';
import DialogPrompt from '../../common/client/components/DialogPrompt';

const classNames = mergeStyleSets({
    CheckUserAccountActivation: {
        margin: 16,
        padding: 16,
        backgroundColor: '#fed9cc'
    },
});

const CheckUserAccountActivation = () => {

    const dispatch = useDispatch();
    const authActions = authGetActions(dispatch);

    const token = useAuthToken();
    const needActivation = useAuthNeedActivation();

    const handleActivateClick = async () => {
        const message = `Zadejte aktivační kód, který jste obdrželi v zaslaném emailu.`;
        let activationCode = await DialogPrompt.show(message);
        if (activationCode) {
            authActions.activate(token, activationCode);
        }
    }

    const handleSendClick = () => {
        authActions.sendActivation(token);
    }

    if (needActivation) {
        return (
            <Stack className={classNames.CheckUserAccountActivation} tokens={{childrenGap: 8}}>
                <Text>
                    <>Aktuálně jste přihlášeni s uživatelským účtem, který není aktivován. </>
                    <>Aktivací účtu získáte přístup k jednotlivým aplikacím a dalším rozšířeným funkcím. </>
                    <>Aktivaci provedete zadáním aktivačního kódu, který Vám byl zaslán na Vaši e-mailovou adresu zadanou při registraci. </>
                    <>Jestliže aktivační e-mail nemáte, můžete si jej nechat zaslat znovu. </>
                </Text>
                <Stack horizontal horizontalAlign="end" tokens={{childrenGap: 4}}>
                    <PrimaryButton
                        text="Zadat aktivační kód"
                        onClick={handleActivateClick}
                    />
                    <DefaultButton
                        text="Znovu odeslat aktivační e-mail"
                        onClick={handleSendClick}
                    />
                </Stack>
            </Stack>
        );
    }
    return null;
}

export default CheckUserAccountActivation;
